import { usePartnerConfig } from '~/stores/usePartnerConfig';
import {LANG} from "~/enums/Lang";

export default defineNuxtRouteMiddleware((to, from) => {
  const { domain } = usePartnerConfig();

  const supportedLocales = [
    'en', 'ar', 'ru', 'cs', 'da', 'bg', 'nl', 'et', 'de', 'uk',
    'es', 'tr', 'zh', 'pt', 'fi', 'fr', 'el', 'hu', 'id', 'it',
    'ja', 'ko', 'lv', 'lt', 'nb', 'pl', 'ro', 'sk', 'sl', 'sv'
  ];

  const currentPath = to.path.replace(/^\/(en|ar|ru|cs|da|bg|nl|et|de|uk|es|tr|zh|pt|fi|fr|el|hu|id|it|ja|ko|lv|lt|nb|pl|ro|sk|sl|sv)(\/|$)/, '/');

  const links = supportedLocales.map((locale: string) => {
    return {
      rel: 'alternate',
      hreflang: locale === LANG.EN ? 'x-default' : locale,
      href: `https://${domain.value}` + `/${locale}${currentPath}`
    }
  })

  useHead({
    link: links
  });
});